<template>
    <div class="report-share-view">
        <div v-if="loading" class="report-share-status">
            <v-progress-circular indeterminate color="primary" size="40" />
        </div>
        <div v-else-if="error" class="report-share-status">
            <v-icon size="48" color="grey">mdi-file-remove</v-icon>
            <p class="mt-4 grey--text">This report link is no longer available.</p>
        </div>
        <report-renderer v-else :report="report" :project="project" :company-id="companyId" :show-actions="true" />
    </div>
</template>

<script>
    import ReportRenderer from "../../components/reports/ReportRenderer.vue"
    import { resolveApiRoot, normalizeSections } from "../../components/reports/reportApi"

    export default {
        name: "ReportShareView",
        components: { ReportRenderer },
        data() {
            return {
                loading: true,
                error: false,
                report: null,
                project: null,
                companyId: ""
            }
        },
        async mounted() {
            this.companyId = decodeURIComponent(this.$route.params.companyId)
            // Firma und Projekt gehen als Props bis in BrandLineChart (TrendChartsSection). localStorage.company_id
            // darf hier NICHT gesetzt werden: ein eingeloggter Nutzer, der den Link einer anderen Firma öffnet,
            // hätte sonst in allen Tabs der App deren company_id.
            try {
                const apiRoot = resolveApiRoot(this.companyId)
                const res = await this.$helpers.axiosPost(apiRoot + "/ai-suite/reports/public", {
                    company_id: this.companyId,
                    token: this.$route.params.token
                })
                this.report = res.data.report
                this.report.sections = normalizeSections(this.report.sections).filter((s) => s.enabled)
                try {
                    const projRes = await this.$helpers.axiosPost(apiRoot + "/project/one", {
                        company_id: this.companyId,
                        project_id: this.report.project_id
                    })
                    this.project = projRes.data
                } catch (e) {
                    this.project = null
                }
            } catch (e) {
                this.error = true
            } finally {
                this.loading = false
            }
        }
    }
</script>

<style scoped>
    .report-share-view {
        min-height: 100vh;
        background: #f1f5f9;
        padding: 24px 0;
    }
    .report-share-status {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 80vh;
    }
</style>
